import RecordListTabContent from './RecordListTabContent';

export default RecordListTabContent;